import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcClose16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { Button, FAB } from '@gem/ui-kit';

import { useUnknownUserPresenter } from 'APP/main/ChatView/UnknownUser/UnknownUser.presenter';

import styles from './UnknownUser.styles.m.css';
import { UnknownUserBlock } from './UnknownUserBlock/UnknownUserBlock';

interface IUnknownUserProps {
  groupId: string;
}

export const UnknownUser: FC<IUnknownUserProps> = observer((props) => {
  const { groupId } = props;
  const { t } = useTranslation();

  const presenter = useUnknownUserPresenter(groupId);

  if (!presenter.isShowUnknownUserBanner) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.username}>
        {t('common_user_in_not_contact', {
          0: presenter.user?.displayName,
          interpolation: { escapeValue: false },
        })}
      </div>
      <div className={styles.actions}>
        <UnknownUserBlock
          userId={presenter.opponentId!}
          className={styles.action}
          groupId={groupId}
        />
        {presenter.isShowAddContact && (
          <Button
            onClick={presenter.onAddToContact}
            className={styles.action}
            theme="text-secondary"
          >
            {t('common_add_to_contact')}
          </Button>
        )}
        <FAB
          className={styles.close}
          Icon={IcClose16Icon}
          size="20"
          theme="2"
          onClick={presenter.onClose}
        />
      </div>
    </div>
  );
});
